export default __webpack_public_path__ + "static/media/tapas.f2599f52.png";